/* eslint-disable no-underscore-dangle */
import React, { useEffect } from 'react';
import Box from '@mui/material/Box';
import { DataGrid, GridActionsCellItem, GridToolbarQuickFilter } from '@mui/x-data-grid';
import { Button, Stack, Chip, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
// import RoleAdd from './add';
import LoadingSkeleton from '../../../utils/LoadingSkeleton';
import NoRowsOverlay from '../../../utils/NoRowOverlay';
// import RoleEdit from './edit';
import OfficesignatureDelete from './delete';
import SettingAction from '../../../store/actions/SettingAction';
import CopyInput from '../../../components/CopyInput';
import useHasPermission from '../../../utils/useHasPermission';
import { signature, show, store, update, destroy } from '../../../utils/constants';

function QuickSearchToolbar() {
  return (
    <Box
      className="tableTopWrap page__title"
      sx={{
        borderBottom: '1px solid rgba(0,0,0,0.1)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        p: 3
      }}
    >
      <Stack direction="row" sx={{ ml: 'auto' }} spacing={2} className="MuiDataGrid-Search">
        <GridToolbarQuickFilter
          quickFilterParser={(searchInput) => searchInput.split(',').map((value) => value.trim())}
          quickFilterFormatter={(quickFilterValues) => quickFilterValues.join(', ')}
          debounceMs={800} // time before applying the new quick filter value
          variant="outlined"
          size="small"
          sx={{ pb: 0, maxWidth: '275px' }}
        />
        {useHasPermission(signature, store) && (
          <Button
            className="button_primary"
            variant="contained"
            size="small"
            color="secondary"
            component={Link}
            to="/settings/signature/add"
          >
            Add Signature
          </Button>
        )}
      </Stack>
    </Box>
  );
}

export default function SignatureSettings() {
  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 10
  });
  const [sortInfo, setSortInfo] = React.useState({
    sortField: '',
    sort: ''
  });
  const navigate = useNavigate();
  const [searchWord, setSearchWord] = React.useState('');
  // const [editOpen, setEditOpen] = React.useState(false);
  const [deleteOpen, setDeleteOpen] = React.useState(false);
  const [itemId, setItemId] = React.useState('');
  const [rowCountState, setRowCountState] = React.useState(0);
  const [data, setData] = React.useState([]);
  const dispatch = useDispatch();
  const { signListData, isLoading } = useSelector((state) => state.setting); // Replace 'data' with your reducer name

  useEffect(() => {
    dispatch(SettingAction.getAllSignature(paginationModel, sortInfo, searchWord));
  }, [dispatch, paginationModel, sortInfo, searchWord]);

  useEffect(() => {
    if (signListData) {
      if (signListData.data) {
        setData(signListData.data);
      } else {
        setData([]);
      }
      setRowCountState((prevRowCountState) =>
        signListData.total !== undefined ? signListData.total : prevRowCountState
      );
    }
  }, [signListData]);

  console.log(data, '- Completed');
  const columns = [
    {
      field: 'unique_id',
      headerName: '',
      align: 'left',
      flex: 0.3,
      renderCell: (params) => {
        if (params && params.value) {
          return <CopyInput id={params.value} />;
        }
        return null;
      }
    },
    {
      field: 'name',
      headerName: 'Name',
      flex: 1
    },
    {
      field: 'addresses',
      headerName: 'Office Addresses',
      sortable: false,
      flex: 1,
      renderCell: (params) => {
        if (params && params.value && params.value.length > 0) {
          return (
            <Typography component="p" variant="body1">
              {params.value.join(', ')}
            </Typography>
          );
        }
        return null;
      }
    },
    // {
    //   field: 'full_signature',
    //   headerName: 'Full signature',
    //   flex: 1,
    //   renderCell: (params) => {
    //     if (params && params.value) {
    //       return (
    //         <Typography variant="body1" sx={{ whiteSpace: 'pre-line' }}>
    //           {params.value}
    //         </Typography>
    //       );
    //     }
    //     return null;
    //   }
    // },
    {
      field: 'status',
      headerName: 'Status',
      flex: 1,
      renderCell: (params) => {
        if (params && params.value) {
          return params.value === 1 ? (
            <Chip label="Active" color="success" />
          ) : (
            <Chip label="Inactive" color="lignhtwarning" />
          );
        }
        return null;
      }
    },
    useHasPermission(signature) && {
      field: 'actions',
      type: 'actions',
      headerName: 'Actions',
      flex: 1,
      getActions: (params) => [
        signature && useHasPermission(signature, show) ? (
          <GridActionsCellItem
            key={0}
            icon={<i className="icon-view" />}
            className="actionBtn"
            title="View"
            label="View"
            onClick={() => {
              navigate(`/settings/signature/view/${params.id}`);
            }}
          />
        ) : (
          <span />
        ),
        signature && useHasPermission(signature, update) ? (
          <GridActionsCellItem
            key={1}
            icon={<i className="icon-edit" />}
            className="actionBtn"
            title="Edit"
            label="Edit"
            onClick={() => {
              navigate(`/settings/signature/edit/${params.id}`);
            }}
          />
        ) : (
          <span />
        ),
        signature && useHasPermission(signature, destroy) ? (
          <GridActionsCellItem
            key={2}
            icon={<i className="icon-delete" />}
            className="actionBtn"
            title="Delete"
            label="Delete"
            onClick={() => {
              setDeleteOpen(true);
              setItemId(params.id);
            }}
          />
        ) : (
          <span />
        )
      ]
    }
  ];

  const handleSortModelChange = React.useCallback((sortModel) => {
    // Here you save the data you need from the sort model
    if (sortModel.length > 0) {
      const { field, sort } = sortModel[0];
      const sortData = {
        sortField: field,
        sort
      };
      setSortInfo(sortData);
    }
    // eslint-disable-next-line
  }, []);

  const onFilterChange = React.useCallback((filterModel) => {
    // Here you save the data you need from the filter model
    const searchKeyword = filterModel.quickFilterValues[0];
    setSearchWord(searchKeyword);
    setPaginationModel({ page: 0, pageSize: 10 });
    // eslint-disable-next-line
  }, []);

  return (
    <Box sx={{ mb: 3 }} className="cardWrapper">
      <div className="pageTitleWrap">
        <Stack direction="row" spacing={1} alignItems="center">
          <Typography component="h2" variant="h2">
            Signature Configuration
          </Typography>
        </Stack>
      </div>
      <Box sx={{ bgcolor: 'white' }} className="dataTable__wrap">
        <DataGrid
          rows={data}
          getRowId={(row) => row._id}
          rowCount={rowCountState}
          columns={columns}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 10
              }
            }
          }}
          autoHeight
          sx={{ minHeight: 650, '--DataGrid-overlayHeight': '300px' }}
          disableColumnFilter
          rowHeight={50}
          slots={{
            toolbar: QuickSearchToolbar,
            loadingOverlay: LoadingSkeleton,
            noRowsOverlay: NoRowsOverlay
          }}
          pageSizeOptions={[10, 25, 50, 100]}
          paginationModel={paginationModel}
          paginationMode="server"
          onPaginationModelChange={setPaginationModel}
          sortingMode="server"
          onSortModelChange={handleSortModelChange}
          filterMode="server"
          onFilterModelChange={onFilterChange}
          disableRowSelectionOnClick
          loading={isLoading}
        />
      </Box>

      {/* {editOpen === true ? (
        <RoleEdit openmodal={editOpen} itemId={itemId} onCloseModal={() => setEditOpen(false)} />
      ) : (
        ''
      )} */}
      {deleteOpen === true ? (
        <OfficesignatureDelete
          openmodal={deleteOpen}
          itemId={itemId}
          onCloseModal={() => setDeleteOpen(false)}
        />
      ) : (
        ''
      )}
    </Box>
  );
}
